var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-6"},[_c('h3',{staticClass:"font-medium mb-2 text-xl leading-tight"},[_vm._v("\n    "+_vm._s(_vm.headline)+"\n  ")]),_vm._v(" "),_c('Richtext',{staticClass:"richtext hyphens",attrs:{"content":_vm.body}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }